<ng-template #template>
  <ndw-modal
    [ngStyle]="{
      width: width(),
      'max-width': maxWidthToUse,
      'min-height': minHeight() ? minHeight() : 'auto',
    }"
    [size]="size()"
    [class]="customClasses()"
  >
    <ndw-modal-header>
      {{ title() }}
      <ng-content select=".modal-header"></ng-content>
    </ndw-modal-header>
    <ndw-modal-content [class.no-scroll]="noScroll()">
      <ng-content select=".modal-body"></ng-content>
    </ndw-modal-content>
    <ndw-modal-footer>
      <ng-content select=".modal-footer"></ng-content>
      @if (confirmText()) {
        <ng-container>
          <button
            ndwButton
            large
            alternative
            secondary
            (click)="close()"
            data-test-id="modal-cancel"
          >
            Annuleren
          </button>
          <button
            ndwButton
            large
            [disabled]="confirmDisabled() || isSubmitting()"
            data-test-id="modal-confirm"
            (click)="confirm()"
          >
            @if (isSubmitting()) {
              <ndw-loader></ndw-loader>
            }

            {{ confirmText() }}
          </button>
        </ng-container>
      }
    </ndw-modal-footer>
  </ndw-modal>
</ng-template>
